import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { HomeConstants } from '../../home/store/home.constants'
import { initialCompleteChartState } from '../store/completeChart.reducers'
import { PcrDocsService } from '../../../services/pcrDocs.service'

export function* initializeCompleteChartData() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  try {
    if (pcrID) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pcrDocUpdated: IPcr = {
        ...pcrDoc,
        completeChart: {
          ...initialCompleteChartState,
        },
      }

      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    }
  } catch (e) {
    yield put(throwPcrException(`initializeCompleteChartDataSaga() error: ${e}`))
  }
}

export function* initializeCompleteChartDataSaga() {
  yield takeLatest([HomeConstants.SET_NEW_PCR], performWithMutexHOG, initializeCompleteChartData)
}
